import { TrashIcon } from "@heroicons/react/24/outline";
import ModalConfirm from "../Modal/ModalConfirm";
import ModalLoading from "../Modal/ModalLoading";
import useConfirmCallback from "/src/hooks/useConfirmCallback";
import useQueryEffect from '/src/hooks/useQueryEffect';
import { useDeletePlotOwnerMutation } from "/src/redux/plotsApi";

export default function MapEditorPlotOwnerDelete({_id, onDelete, onError}){
    const [deletePlotOwner, { error, isLoading, isSuccess }] = useDeletePlotOwnerMutation();
    const [confirmDeleteThen, onConfirmDelete] = useConfirmCallback();

    const userTookAction = useQueryEffect((error)=>{
        if(error){
            onError(error);        
        }else{
            onDelete(_id)
        }
    }, [isSuccess, onDelete],[error, onError]);


    // handle user clicking plot delete button
    function _onDelete(_id){
        confirmDeleteThen(choice=>{
            if(choice){
                userTookAction();
                deletePlotOwner(_id);
            }
        });
    }

    return (
        <div className='flex flex-col'>
            {onConfirmDelete && <ModalConfirm message={`Are you sure you want to delete this person from this plot? This cannot be undone.`} callback={onConfirmDelete} />}
            {isLoading && <ModalLoading title="Deleting" absolute="true" />}
            <button className='btn-danger flex items-center' disabled={!_id} onClick={()=>_onDelete(_id)}>
                <TrashIcon className='w-6 mr-3' />
                <span>Delete Person</span>
            </button>
        </div>
    )
    
}